import React, { useState, useEffect } from 'react';
import ViewBooking from '../../manageAccount/ViewBooking';
import CancelDetails from '../../cancel/cancelDetails';
import Edit from '../../edit/edit';
import moment from 'moment';
import { renderSvg } from '../../manageAccount/renderSvg';
import { bookAgain, getDateFormatIPhone2 } from '../../common/helper';
import { t, VIEW_BOOKING, CLOSE_BOOKING, MODIFY_BOOKING, CANCEL_BOOKING, BOOK_AGAIN, PNR, TRIP_CODE, BUS_TYPE, BOOKED_ON, VIEW_ON_MAP, CLOSE_MODIFY_BOOKING, CLOSE_CANCEL_BOOKING } from '../../../translations/ManageAccount/CardList';
import { apiUrl } from './constants';
import { GetRequest } from './helper';

const Bookingcard = (props) => {
    const { cardData } = props;

    const [mobile, setMobile] = useState(props.mobile)

    const [data, setData] = useState(cardData);

    const getMobileNo = (pnr) => {
        const url = apiUrl.getMobNo + "?pnr=" + pnr;
        GetRequest(url)
            .then((res) => {
                console.log(res)
                // setMobile('8755993810');
                if (res.Success) {
                    setMobile(res.mobile);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }

    const viewBooking = (i, value,) => {
        const data = [...cardData]
        // if (value && !mobile) {
        //     getMobileNo(data[i].BookingRefNo);
        // }
        for(let i =0; i < data.length ; i++){
           data[i].viewBokking = false; 
        }
        data[i].viewBokking = value;
        setData(data)
    }

    const viewCancel = (i, value) => {
        const data = [...cardData];
        // if (value && !mobile) {
        //     getMobileNo(data[i].BookingRefNo)
        // }
        for(let i =0; i < data.length ; i++){
           data[i].showCancel = false; 
        }
        data[i].showCancel = value
        setData(data)
    }

    const viewEdit = (i, value) => {
        const data = [...cardData]
        for(let i =0; i < data.length ; i++){
           data[i].showEdit = false; 
        }
        data[i].showEdit = value
        setData(data)
    }

    const hideEditDetails = (i, value) => {
        const data = [...cardData]
        for(let i =0; i < data.length ; i++){
           data[i].showEdit = false; 
        }
        data[i].showEdit = value
        setData(data)
    }

    console.log("data", data);

    const login = window.customerProfile.isLoggedIn;

    return (
        <div className="rightContent" style={{ width: '100%' }}>
            <div className="cards-wrapper scrollBlue">
                {
                    <React.Fragment>
                        {
                            data.map((val, i) => {

                                return (
                                    <React.Fragment>
                                        <div className="card" key={i}>
                                            <div className="cardHeader" >
                                                <p>{(val.BookingStatus === 'Payment Pending' || val.BookingStatus === 'PDBF' || val.BookingStatus === 'NA') ? "" : t(PNR)} {(val.BookingStatus === 'Payment Pending' || val.BookingStatus === 'PDBF' || val.BookingStatus === 'NA') ? "" : (val.BookingRefNo || val.PNR) + " | "} {t(TRIP_CODE)} {val.TripCode} | {t(BUS_TYPE)}: {val.BusType}
                                                    {((val.BookingStatus === 'Payment Pending' && val.BookingRefNo == "" || val.PNR == "") || val.BookingStatus === 'PDBF' || val.BookingStatus === 'NA') ? "" : ` | ${t(BOOKED_ON)} ${getDateFormatIPhone2(val.BookingDateTime, "DD MMM YY, HH:mm")}`}
                                                </p>

                                                {(val.BookingStatus === 'Payment Pending' || val.BookingStatus === 'PDBF' || val.BookingStatus === 'NA')
                                                    ? ''
                                                    :
                                                    val.viewBokking ?
                                                        <button onClick={() => viewBooking(i, false)}>{t(CLOSE_BOOKING)}</button> :
                                                        <button onClick={() => viewBooking(i, true)}>{t(VIEW_BOOKING)}</button>
                                                }
                                                {/* {
                                                    val.viewBokking ?
                                                        <button onClick={() => viewBooking(i, false)}>{t(CLOSE_BOOKING)}</button> :
                                                        <button onClick={() => viewBooking(i, true)}>{t(VIEW_BOOKING)}</button>
                                                } */}
                                            </div>
                                            <div className="cardContent">
                                                <ul className="cardLeft">
                                                    <li>
                                                        <span className='circle'></span>
                                                        <div className="leftTop-content">
                                                            <h4>{val.FromCityName} on {getDateFormatIPhone2(val.DepartureTime, "DD MMM YY, HH:mm")} </h4>
                                                            <p>{val.PickupName} </p>
                                                            {/* <a>{renderSvg("viewMap")} <u>{t(VIEW_ON_MAP)}</u></a> */}
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <span className='square'></span>
                                                        <div className="leftTop-content">
                                                            <h4>{val.ToCityName} on {getDateFormatIPhone2(val.ArrivalTime, "DD MMM YY, HH:mm")}  </h4>
                                                            <p>{val.DroppoffName} </p>
                                                            {/* <a>{renderSvg("viewMap")} <u>{t(VIEW_ON_MAP)}</u></a> */}
                                                        </div>
                                                    </li>
                                                </ul>
                                                {val.BookingStatus === 'C' ?
                                                    <div className="cardRight">
                                                        <button onClick={() => bookAgain(val)}>{t(BOOK_AGAIN)}</button>
                                                    </div>
                                                    :
                                                    (val.BookingStatus != 'Payment Pending' && val.BookingStatus != 'PDBF' && val.BookingStatus != 'NA') &&
                                                    <div className="cardRight">
                                                        {
                                                            val.showEdit ?
                                                                <button className={val.showEdit ? 'active' : ''} onClick={() => viewEdit(i, false)}>{t(CLOSE_MODIFY_BOOKING)}</button>
                                                                :
                                                                val.BookingStatus === 'B' && val.DepartureTime && (new Date(val.DepartureTime) >= new Date(window.today)) && <button onClick={() => viewEdit(i, true)}>{t(MODIFY_BOOKING)}</button>

                                                        }
                                                        {
                                                            val.showCancel ?
                                                                <button className={val.showCancel ? 'active' : ''} onClick={() => viewCancel(i, false)}>{t(CLOSE_CANCEL_BOOKING)}</button>
                                                                :
                                                                val.BookingStatus === 'B' && val.DepartureTime && (new Date(val.DepartureTime) >= new Date(window.today)) && <button onClick={() => { login ? viewCancel(i, true) : window.location.href = `/guest-cancel?pnr=${val.BookingRefNo || val.PNR}`; }}>{t(CANCEL_BOOKING)}</button>

                                                        }
                                                        <button onClick={() => bookAgain(val)}>{t(BOOK_AGAIN)}</button>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        {
                                            val.viewBokking &&
                                            <div className="viewBooking-wrapper">
                                                <ViewBooking pnr={val.PNR} type={val.BookingStatus === 'C' ? 'C':''} returnBooking={val.returnBooking} mobile={val.mobile} />
                                            </div>
                                        }

                                        {
                                            val.showCancel && <CancelDetails pnr={val.BookingRefNo} mobile={val.mobile} />
                                        }

                                        {
                                            val.showEdit && <Edit
                                                routeID={val.RouteCode || "72~58~1661~894~2024-04-04"}
                                                BookingRefNo={val.BookingRefNo}
                                                PNR={val.PNR}
                                                defPickup={{ id: val.PickupID, name: val.PickupName }}
                                                defDropOff={{ id: val.DropoffID, name: val.DroppoffName }}
                                                cancel={() => hideEditDetails(i, false)}
                                            />
                                        }
                                    </React.Fragment>

                                )
                            })
                        }
                    </React.Fragment>
                }
            </div>
        </div>
    )
}

export default Bookingcard;